import React from "react";

const Error = () => {
    return(
        <div>
            <h1>404 Error</h1>
            <h2>Page does not exist</h2>
        </div>
    );
}

export default Error;